<template lang="html">
  <div class="spread">
    <img class="banner" :src="`${pagebase}/static/img/spread/background.png`" alt="">
    <div class="particularsBtn">
      <p>查看详情</p>
      <img :src="`${pagebase}/static/img/spread/icon.png`" alt="">
      <WxOpenTag :extinfo="openUrl" />
    </div>
  </div>
</template>

<script>
  import WxOpenTag from '@/components/WxOpenTag'
  import {pagebase} from '@/utils/http.js';

  export default {
    data() {
      return {
        pagebase: pagebase,
        openUrl: '',
      }
    },
    
    components: {
      WxOpenTag,
    },
    
    mounted() {
      // 认证
      if(this.$route.query.type == 1) {
        this.$http({
          url: '/eleom/getSmsLink',
          method: 'get',
          params: {
            type: 1,
          },
        }).then(res => {
          if (res.code >= 0) {
            this.openUrl = res.data.data;
          }
        })
      }
      // 活动
      if(this.$route.query.type == 2) {
        this.$http({
          url: '/activity/detail',
          method: 'get',
          params: {
            activity_id: this.$route.query.id,
            track: this.$route.query.track,
          },
        }).then(res => {
          if (res.code >= 0) {
            if(res.data.is_xiaoe_url){
              this.openUrl = 'live/detail?url=' + res.data.live_url;
            } else {
              this.openUrl = res.data.app_live_url;
            }
            
          }
        })
      }
    }
  }
</script>

<style lang="css" scoped>
  .banner {
    width: 100%;
    height: 100%;
  }

  .particularsBtn {
    position: fixed;
    bottom: 6.55rem;
    left: 50%;
    width: 25rem;
    height: 5.3rem;
    line-height: 5.3rem;
    border-radius: 5.3rem;
    background-color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -12.5rem;
  }

  .particularsBtn p {
    font-size: 2.25rem;
    color: #C6101B;
  }

  .particularsBtn img {
    width: 2.3rem;
    height: 2.3rem;
    margin-left: 1rem;
  }
</style>
